import gql from 'graphql-tag';

export const foundationLevelCLAQuery = gql`
  query foundationLevelCla($id: ID!) {
    foundationLevelCla(id: $id) {
      foundationLevelCla
    }
  }
`;
